import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.374 1.96A1 1 0 1 0 1.96 3.374l14.434 14.434A15.6 15.6 0 0 0 16 21.333c0 18.667-8 24-8 24h35.92l16.707 16.708a1 1 0 0 0 1.414-1.414zM47.38 38.19c.004-2.898-1-17-3.766-21.398A16 16 0 0 0 21 11.69zM34.662 57.945A5.33 5.33 0 0 0 36.613 56h-9.226a5.333 5.333 0 0 0 7.275 1.945",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }